import { useState, useEffect } from 'react';
import FilterDrawer, { FilterContainer } from 'src/components/FilterDrawer';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
  Box,
} from '@mui/material';
import { TagFilters } from '../types';
import { tagsValueSetConfig } from '../config/valuesetConfig';

interface TagsFiltersProps {
  open: boolean;
  onClose: Function;
  filters: TagFilters;
  onApplyFilters: (filters: Partial<TagFilters>) => void;
}

const CODE_SYSTEMS = tagsValueSetConfig.codeSystems.map((cs) => cs.code);
const RESOURCES = tagsValueSetConfig.resourceTypes.map((rt) => rt.code);

export default function TagsFilters({
  open,
  onClose,
  filters,
  onApplyFilters,
}: TagsFiltersProps) {
  const [localFilters, setLocalFilters] = useState<TagFilters>(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleApply = () => {
    onApplyFilters(localFilters);
  };

  const handleClear = () => {
    const clearedFilters: TagFilters = {
      codeSystem: [],
      resources: [],
    };
    setLocalFilters(clearedFilters);
    onApplyFilters(clearedFilters);
  };

  const handleClose = (event?: {}, reason?: 'backdropClick' | 'escapeKeyDown') => {
    onClose();
  };

  return (
    <FilterDrawer
      open={open}
      onClose={handleClose}
      onCloseIconButtonClick={onClose}
      title="Filters"
      anchor="right"
      onApplyButtonClick={handleApply}
      onClearAllButtonClick={handleClear}
    >
      <FilterContainer label="Code System">
        <FormControl fullWidth>
          <InputLabel>Code System</InputLabel>
          <Select
            multiple
            value={localFilters.codeSystem || []}
            onChange={(e) =>
              setLocalFilters({ ...localFilters, codeSystem: e.target.value as string[] })
            }
            input={<OutlinedInput label="Code System" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value} label={value} size="small" />
                ))}
              </Box>
            )}
          >
            {CODE_SYSTEMS.map((system) => (
              <MenuItem key={system} value={system}>
                {system}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </FilterContainer>

      <FilterContainer label="Resources">
        <FormControl fullWidth>
          <InputLabel>Resources</InputLabel>
          <Select
            multiple
            value={localFilters.resources || []}
            onChange={(e) =>
              setLocalFilters({ ...localFilters, resources: e.target.value as string[] })
            }
            input={<OutlinedInput label="Resources" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value} label={value} size="small" />
                ))}
              </Box>
            )}
          >
            {RESOURCES.map((resource) => (
              <MenuItem key={resource} value={resource}>
                {resource}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </FilterContainer>
    </FilterDrawer>
  );
}

